import React from 'react';
import * as Styled from './styled';
import { IDataFrameSchema, IDataFrameField } from '@/lib/dataFrameTypes';
import Tag from '@/ui/Tag';
import { isStringField, isNumberField, isIntField, isFloatField, isStructField, isListField } from '@/lib/dataFrameApi';

const getTagVariant = (field: IDataFrameField) => {
  if (isStringField(field)) {
    return 'info';
  }
  if (isIntField(field)) {
    return 'primary';
  }
  if (isFloatField(field)) {
    return 'warning';
  }
  if (isNumberField(field)) {
    return 'warning';
  }
  if (isStructField(field)) {
    return 'success';
  }
  if (isListField(field)) {
    return 'success';
  }
  return 'default';
};

const FieldList: React.FC<
  React.HTMLProps<HTMLDivElement> & {
    schema?: IDataFrameSchema;
    activeFields?: string[];
  }
> = ({ schema, activeFields, ...rest }) => {
  return (
    <Styled.FieldList {...rest}>
      {schema?.fields.map((field) => (
        <Tag
          key={field.name}
          small
          border={activeFields?.includes(field.name)}
          variant={getTagVariant(field)}
          title={`Data type: ${field.dtype}`}
        >
          {field.name}
        </Tag>
      ))}
    </Styled.FieldList>
  );
};

export default FieldList;
